<div [style.opacity]="opacity">
  <div class="mapbox">
    <div
      leaflet
      leafletCtrlToZoom
      [leafletOptions]="leafletOptions"
      (leafletMapReady)="onMapReady($event)"
      (leafletMapMoveEnd)="emitMapMoveEnd()"
      (leafletMapZoomEnd)="emitMapZoomEnd()"
      [ngStyle]="{'height': mHeight ? mHeight : '100%', 'width': mWidth ? mWidth : '100%'}"
      [leafletLayers]="layers"
      [ngClass]="roundedCorners ? 'roundcorners' : ''"
    >
      <ng-container *ngIf="drawing">
        <div
          leafletDraw
          [leafletDrawOptions]="leafletDrawOptions"
          (leafletDrawReady)="onDrawReady($event)"
        >
        </div>
      </ng-container>

    </div>
    <ng-container *ngIf="whatIsHere">
      <div class="mapdropdown overlay"
           [style.top.px]="dropdownTop"
           [style.left.px]="dropdownLeft"
           [style.bottom.px]="dropdownBottom"
           [style.right.px]="dropdownRight"
           [style.display]="dropdownDisplay"
      >
        <ng-scrollbar class="scrollDropdownDeviceOptions">
          <hr>
          <ng-container *ngFor="let option of options()">
            <button class="dropdown-item" type="button" [disabled]="!option.enabled"
                    (click)="callDropdownAction(option.action)">
              <sb-icon class="mr-3 icon-in-btn" [icon]="option.icon"></sb-icon>
              <b [style.color]="option.enabled ? '#000' : '#999'">{{option.text}}</b>
            </button>
            <hr>
          </ng-container>
        </ng-scrollbar>
      </div>
    </ng-container>
  </div>
</div>
